import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function BeforeAfter() {
  return <section className="bg-paper py-16 sm:py-20" aria-labelledby="ba-title" data-id="element-68" data-mp="26luonyxbie5l">
      <div className="mx-auto max-w-5xl px-5" data-id="element-69" data-mp="22krf1u5v5ect">
        <h2 id="ba-title" className="text-center font-display text-[32px] font-black leading-tight text-ink sm:text-[44px]" data-id="element-70" data-mp="22m2ddegjhtwj">
          From this… <em className="text-brand" data-id="element-71" data-mp="2z8nugvpke3mg">to this</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-72" data-mp="2ud8jcbixyltq">
          <div className="rounded-3xl border border-flame/25 bg-flame-light p-6 sm:p-8" data-id="element-73" data-mp="2qa3jyhu5r09b">
            <p className="inline-flex items-center gap-2 rounded-full bg-flame px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-74" data-mp="2lb8z7acmr1mk">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="1ewrmqpswlfw4" /> Before
            </p>
            <ul className="mt-6 space-y-4" data-id="element-76" data-mp="19v27exyneg28">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-77" data-mp="1754amegjre9g">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-flame/15 text-flame" data-id="element-78" data-mp="1c4yy08145lpr">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-79" data-mp="y463voeq4sn6" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 text-white sm:p-8" data-id="element-80" data-mp="odbj6oh4m13u">
            <p className="inline-flex items-center gap-2 rounded-full bg-sky px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-81" data-mp="t5ux5mjq6y96">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="fc3lo8mfp4at" /> With the Safe Spine Method™
            </p>
            <ul className="mt-6 space-y-4" data-id="element-83" data-mp="jdfa4atknjhf">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-white" data-id="element-84" data-mp="5i3gk6r5jz23">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky text-ink" data-id="element-85" data-mp="ah6cn1p5muxx">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-86" data-mp="27dkjb8wc06kt" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-87" data-mp="1yde4njowd0k2">
          <CtaButton label="I want the Safe Spine Method™" caption="Stop reinventing your process with every patient" data-id="element-88" data-mp="1yefitx17m360" />
        </div>
      </div>
    </section>;
}